import { trim, utils, webxError, webxErrorType, hongKongHostMap } from '@didi/webx-js-core';
// import { bizToXenvMap } from './bizToXenv'
import { getBranch } from '../initSDK';
import { query, hashQuery, parseURL } from '../query';
let regs = {
    'android': /android/i,
    'iphone': /iphone/i,
    'ipad': /ipad/i,
    'ipod': /ipod/i,
    'rPassenger': /com.sdu.didi.psnger/i,
    'weixin': /micromessenger/i,
    'mqq': /QQ\//i,
    'alipay': /alipayclient/i,
    'miniprogram': /miniprogram/i,
    'passenger': /didi.passenger/i,
    'driverAndroid': /didigsui/i,
    'driverIOS': /ddudriver/i,
    'fusion': /fusionkit/i,
    'kfpassenger': /kflower\.passenger/i,
    'kfdriver': /kflower(\.|u)driver/i,
    'esapp': /didies/i,
    'hitchapp': /blord/i,
    'hydriver': /freight.driver/i
};
function parseUserAgent() {
    let ret = {}, ua = window.navigator.userAgent;
    for (let key in regs) {
        ret[key] = regs[key].test(ua);
    }
    ret.ios = ret.iphone || ret.ipad || ret.ipod;
    ret.driver = ret.driverAndroid || ret.driverIOS;
    ret.native = ret.passenger || ret.rPassenger || ret.kfdriver || ret.kfpassenger || ret.driver || ret.hydriver;
    return ret;
}
/**
 * 检测当前环境,用于直接检测当前环境是否符合对应字符串。
 * @param strs 所需要判断的环境str。可判断的环境取值参考文档，"."代表并，","代表或
 * @returns boolean
 * @example
 * ```js
 *  is('passenger') // 乘客端
 *  is('passenger,kfpassenger') // 滴滴乘客端或花小猪客户端
 *  is('passenger.ios') // 滴滴乘客端且ios系统
 * ```
 */
export function is(strs) {
    let str = strs.split(',');
    let ua = parseUserAgent();
    let check = function (rote) {
        rote = trim(rote) || '';
        if (!rote) {
            return false;
        }
        let rotes = rote.split('.');
        let ret = true;
        utils.each(rotes, function (r) {
            if (!ua[r]) {
                ret = false;
                return false;
            }
        });
        return ret;
    };
    let ret = false;
    utils.each(str, function (s) {
        if (check(s)) {
            ret = true;
            return false;
        }
    });
    return ret;
}
export let isHK = false;
try {
    if (is('miniprogram')) {
        isHK = query().isHK || Object.values(hongKongHostMap).some(hkHost => new RegExp(hkHost).test(parseURL().hostAndPath));
    }
    else {
        isHK = Object.values(hongKongHostMap).some(hkHost => new RegExp(hkHost).test(parseURL().hostAndPath));
    }
}
catch (error) {
    isHK = false;
}
function processBizXenv(branch) {
    // TBD: 降级逻辑暂时不考虑
    // let currentXenvList = bizToXenvMap[branch]
    let xenv;
    let Query = Object.assign({}, query(), hashQuery());
    if (is('miniprogram')) {
        /* 小程序webview内获取xenv
         * 1.优先获取url上携带的
         * 2.否则设置默认：微信小程序webview都用wxmp，支付宝小程序都用alimp
         */
        if (Query.xenv) {
            xenv = Query.xenv;
        }
        else if (is('weixin')) {
            xenv = 'wxmp';
        }
        else if (is('alipay')) {
            xenv = 'alimp';
        }
        else if (is('mqq')) {
            xenv = 'qqmp';
        }
        // xenv =  Query.xenv || (is('weixin') ? 'wxmp' : 'alimp')
    }
    else if (is('hitchapp')) {
        xenv = 'hitchapp';
    }
    else if (is('passenger')) {
        xenv = 'passenger';
    }
    else if (is('driver')) {
        xenv = 'driver';
    }
    else if (is('kfpassenger')) {
        xenv = 'kfpassenger';
    }
    else if (is('kfdriver')) {
        xenv = 'kfdriver';
    }
    else if (is('rPassenger')) {
        xenv = 'capp';
    }
    else if (is('esapp')) {
        xenv = 'esapp';
    }
    else if (is('hydriver')) {
        xenv = 'hydriver';
    }
    else if (is('weixin')) {
        xenv = 'weixin';
    }
    else if (is('alipay')) {
        xenv = 'alipay';
    }
    else if (is('mqq')) {
        xenv = 'mqq';
    }
    else {
        xenv = 'h5';
    }
    return xenv;
}
export function xenv() {
    if (getBranch()) {
        return processBizXenv(getBranch());
    }
    else {
        webxError({
            type: webxErrorType.WEBX_INIT,
            msg: '请先使用webx.init设置环境'
        });
    }
}
// 运行环境映射到目标环境-{init传入环境参数: [运行环境, 目标环境]
const rewriteXenvMap = {
    // 花小猪乘客业务H5在滴滴出行乘客NA中投放，采用H5登录
    'kfpassenger': ['passenger', 'h5'],
    'passenger': false,
    'cxapp': false,
    'driver': false,
    'kfdriver': false
};
// 重写当前运行环境 
export function rewriteXenv() {
    const rewriteXenvBranch = rewriteXenvMap[getBranch()];
    if (rewriteXenvBranch) {
        if (xenv() === rewriteXenvBranch[0]) {
            return rewriteXenvBranch[1];
            // 常规情况
        }
    }
    return xenv();
}
export const ua = parseUserAgent();
// TODO:能够推导出return值，目前是any，外部需要使用类型断言
export function xenvActionFactory(api, option) {
    const _xenv = rewriteXenv();
    if (!(_xenv in option) || typeof option[_xenv] !== 'function') {
        webxError({
            type: webxErrorType.API_NOT_SUPPORT,
            msg: `当前环境${xenv}不支持${api}`
        });
    }
    return option[_xenv];
}
